import { Contacts } from "acquaint-api/models/Contacts";

export class ContactHelper {
  static formatContactName = (contractor: Contacts) => {
    if (contractor.businessCompany) {
      return `${contractor.firstNames} ${contractor.lastName} (${contractor.businessCompany})`;
    } else {
      return `${contractor.firstNames} ${contractor.lastName}`;
    }
  };
}
